import { NODE_TYPE_ITEM } from '../../types/nodeTypes';
import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, {
  IMAGE_DISABLED,
  IMAGE_EDITABLE,
  IMAGE_VIEW,
} from './DefaultCatalogConfig';

export default class StoreCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);
    this.editable = props.isStoreEditor;
    this.allowedSources = [props.productsCatalogId];
    this.category.autoCategorisable = false;
    this.category.rename = props.isStoreEditor;
    this.category.delete = props.isGlobalMarket && props.isStoreEditor;
    this.category.comment = props.isStoreEditor;
    this.category.import = false;
    this.category.publish = props.isStoreEditor;
    this.category.hide = props.isStoreEditor;
    this.category.translation = props.isStoreEditor;
    this.category.levelRestriction = true;
    this.category.levelEditable = [1];
    this.category.image = props.isStoreEditor ? IMAGE_EDITABLE : IMAGE_VIEW;
    this.category.productImage = IMAGE_DISABLED;
    this.category.publishMinDaysDelay = 0;
    this.category.categoryImageLevelRestriction = [1];

    if (props.isGlobalMarket && props.isStoreEditor) {
      this.category.deleteCategoryLevels = [1, 2];
    }

    this.category.redirectIdRequired = false;

    this.catalog.availableForMarkets = props.isGlobalMarket && props.isStoreEditor;
    this.catalog.translation = !props.isGlobalMarket && props.isStoreEditor;

    this.item.copy = false;
    this.item.remove = false;
    this.item.cut = false;

    this.allowRanking = props.isStoreEditor;
    this.allowRankingLevels = [1, 2];
    this.newCategory = props.isStoreEditor;
    this.allowCutCategory = false;
    this.allowCopyCategory = props.isStoreEditor;
    this.moveDisabled = false;
    this.allowHoverActions = props.isStoreEditor;

    this.canCopyNode = (node) => {
      if (node.level === 1) return false;

      return true;
    };

    this.canPaste = ({ nextParent, node }) => {
      if (!this.editable) return false;
      if (!this.allowedSources.includes(node?.catalogId)) return false;

      if (
        node?.type === NODE_TYPE_ITEM &&
        nextParent?.category?.childItemCount > 0
      ) {
        return true;
      }
      return nextParent?.level === 1;
    };
  }
}
